import { createSlice } from '@reduxjs/toolkit';

export const trustedForm = createSlice({
  name: 'TRUSTED_FORM',
  initialState: {}, // declare in store, not here as it will be over written by store

  reducers: {
    addConsentCertificationRecord(state, action) {
      return {
        ...state,
        consentCertification: [
          ...state.consentCertification,
          action.payload.consentCertificationRecord,
        ],
      };
    },
    setIsTrustedFormLoggingEnabled(state, action) {
      const { isTrustedFormLoggingEnabled } = action.payload;
      return {
        ...state,
        isTrustedFormLoggingEnabled,
      };
    },
  },
});

const { actions, reducer } = trustedForm;

export const { addConsentCertificationRecord, setIsTrustedFormLoggingEnabled } =
  actions;

export default reducer;
